import { IStream } from '../../types/IStream';

export const searchRegex = (searchQuery: string): RegExp => new RegExp(searchQuery, 'i');

export const filterStreams = (streams: IStream[], searchQuery: string) => streams
  .filter((s) => s.name.search(searchRegex(searchQuery)) !== -1);
